'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var utils = require('../utils');
var ButtonJustify = _interopDefault(require('../button-justify'));
var SuspendMenu = _interopDefault(require('../suspend-menu'));
var Picker = _interopDefault(require('../picker'));

var monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var dayList = Array.apply(null, Array(31)).map(function (n, i) {
  return i + 1;
});
var hourList = Array.apply(null, Array(24)).map(function (n, i) {
  return i;
});
var minuteList = Array.apply(null, Array(60)).map(function (n, i) {
  return i;
});
var secondList = Array.apply(null, Array(60)).map(function (n, i) {
  return i;
});
var now = new Date();
var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('suspend-menu', {
      staticClass: "date-picker",
      attrs: {
        "show": _vm.show
      },
      on: {
        "clickMask": function clickMask($event) {
          _vm.$emit('hide');
        }
      }
    }, [_c('button-justify', {
      attrs: {
        "left": "取消",
        "right": "确认"
      },
      on: {
        "clickLeft": function clickLeft($event) {
          _vm.$emit('cancel');
        },
        "clickRight": _vm.onConfirm
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "date-picker-container"
    }, [_vm.formatOptions.year ? _c('picker', {
      attrs: {
        "options": _vm.year
      },
      model: {
        value: _vm.selectedYear,
        callback: function callback($$v) {
          _vm.selectedYear = $$v;
        },
        expression: "selectedYear"
      }
    }) : _vm._e(), _vm._v(" "), _vm.formatOptions.month ? _c('picker', {
      attrs: {
        "options": _vm.month
      },
      model: {
        value: _vm.selectedMonth,
        callback: function callback($$v) {
          _vm.selectedMonth = $$v;
        },
        expression: "selectedMonth"
      }
    }) : _vm._e(), _vm._v(" "), _vm.formatOptions.day ? _c('picker', {
      attrs: {
        "options": _vm.day
      },
      model: {
        value: _vm.selectedDay,
        callback: function callback($$v) {
          _vm.selectedDay = $$v;
        },
        expression: "selectedDay"
      }
    }) : _vm._e(), _vm._v(" "), _vm.formatOptions.hour ? _c('picker', {
      attrs: {
        "options": _vm.hour
      },
      model: {
        value: _vm.selectedHour,
        callback: function callback($$v) {
          _vm.selectedHour = $$v;
        },
        expression: "selectedHour"
      }
    }) : _vm._e(), _vm._v(" "), _vm.formatOptions.minute ? _c('picker', {
      attrs: {
        "options": _vm.minute
      },
      model: {
        value: _vm.selectedMinute,
        callback: function callback($$v) {
          _vm.selectedMinute = $$v;
        },
        expression: "selectedMinute"
      }
    }) : _vm._e(), _vm._v(" "), _vm.formatOptions.second ? _c('picker', {
      attrs: {
        "options": _vm.second
      },
      model: {
        value: _vm.selectedSecond,
        callback: function callback($$v) {
          _vm.selectedSecond = $$v;
        },
        expression: "selectedSecond"
      }
    }) : _vm._e()], 1)], 1);
  },
  staticRenderFns: [],
  name: 'date-picker',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    max: {
      type: Date,
      default: function _default() {
        return new Date(now.getFullYear() + 15, 11, 31);
      }
    },
    min: {
      type: Date,
      default: function _default() {
        return now;
      }
    },
    format: {
      type: String,
      default: 'yyyy/MM/dd'
    },
    startYear: {
      type: Number,
      default: now.getFullYear()
    },
    startMonth: {
      type: Number,
      default: now.getMonth() + 1
    },
    startDay: {
      type: Number,
      default: now.getDate()
    },
    startHour: {
      type: Number,
      default: now.getHours()
    },
    startMinute: {
      type: Number,
      default: now.getMinutes()
    },
    startSecond: {
      type: Number,
      default: now.getSeconds()
    },
    indefinitely: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Picker: Picker,
    SuspendMenu: SuspendMenu,
    ButtonJustify: ButtonJustify
  },
  data: function data() {
    return {
      startMimute: 0,
      selectedYear: 0,
      selectedMonth: 0,
      selectedDay: 0,
      selectedHour: 0,
      selectedMinute: 0,
      selectedSecond: 0
    };
  },
  computed: {
    formatOptions: function formatOptions() {
      return {
        year: this.findRule(['yyyy', 'yy']),
        month: this.findRule(['MM']),
        day: this.findRule(['dd']),
        hour: this.findRule(['hh']),
        minute: this.findRule(['mm']),
        second: this.findRule(['ss'])
      };
    },
    isLongTerm: function isLongTerm() {
      if (this.year.length === 0) {
        return false;
      }

      return this.year[this.selectedYear].value === Infinity;
    },
    range: function range() {
      var min = this.min;
      var max = this.max;
      return {
        minYear: min.getFullYear(),
        maxYear: max.getFullYear(),
        minMonth: min.getMonth(),
        maxMonth: max.getMonth(),
        minDay: min.getDate(),
        maxDay: max.getDate(),
        minHour: min.getHours(),
        maxHour: max.getHours(),
        minMinute: min.getMinutes(),
        maxMinute: max.getMinutes(),
        minSecond: min.getSeconds(),
        maxSecond: max.getSeconds()
      };
    },
    year: function year() {
      var year = [];

      if (this.findRule(['yyyy', 'yy'])) {
        for (var i = this.range.minYear; i <= this.range.maxYear; i++) {
          year.push({
            text: i + '年',
            value: i
          });
        }
      }

      if (this.indefinitely) {
        year.push({
          text: '长期',
          value: Infinity
        });
      }

      return year;
    },
    month: function month() {
      var _this = this;

      var month = [];

      if (this.findRule(['MM'])) {
        var year = this.year[this.selectedYear].value;
        month = monthList.map(function (month) {
          return {
            text: _this.pad(month) + '月',
            value: _this.pad(month),
            disabled: _this.isLongTerm ? true : _this.isDisabledMonth(year, month)
          };
        });
      }

      return month;
    },
    day: function day() {
      var _this2 = this;

      var day = [];

      if (this.findRule(['dd'])) {
        var year = this.year[this.selectedYear].value;
        var month = this.month[this.selectedMonth].value;
        day = dayList.map(function (day) {
          return {
            text: _this2.pad(day) + '日',
            value: _this2.pad(day),
            disabled: _this2.isLongTerm ? true : _this2.isDisabledDay(year, Number(month), day)
          };
        });
      }

      return day;
    },
    hour: function hour() {
      var _this3 = this;

      return hourList.map(function (hour) {
        return {
          text: _this3.pad(hour) + '时',
          value: _this3.pad(hour)
        };
      });
    },
    minute: function minute() {
      var _this4 = this;

      return minuteList.map(function (minute) {
        return {
          text: _this4.pad(minute) + '分',
          value: _this4.pad(minute)
        };
      });
    },
    second: function second() {
      var _this5 = this;

      return secondList.map(function (second) {
        return {
          text: _this5.pad(second) + '秒',
          value: _this5.pad(second)
        };
      });
    }
  },
  mounted: function mounted() {
    this.setStartYear();
    this.setStartMonth();
    this.setStartDay();
    this.setStartHour();
    this.setStartMinute();
    this.setStartSecond();
  },
  methods: {
    setStartYear: function setStartYear() {
      this.selectedYear = this.findIndex(this.year, this.startYear);
    },
    setStartMonth: function setStartMonth() {
      this.selectedMonth = this.findIndex(this.month, this.startMonth);
    },
    setStartDay: function setStartDay() {
      this.selectedDay = this.findIndex(this.day, this.startDay);
    },
    setStartHour: function setStartHour() {
      this.selectedHour = this.findIndex(this.hour, this.startHour);
    },
    setStartMinute: function setStartMinute() {
      this.selectedMinute = this.findIndex(this.minute, this.startMimute);
    },
    setStartSecond: function setStartSecond() {
      this.selectedSecond = this.findIndex(this.second, this.startSecond);
    },
    pad: function pad(num) {
      return (num < 10 ? '0' : '') + num;
    },
    findRule: function findRule(rules) {
      for (var i in rules) {
        if (this.format.indexOf(rules[i]) >= 0) {
          return true;
        }
      }

      return false;
    },
    findIndex: function findIndex(arr, val) {
      var index = -1;

      for (var arrIndex = 0; arrIndex < arr.length; arrIndex++) {
        var element = arr[arrIndex];

        if (Number(element.value) === val) {
          index = arrIndex;
          break;
        }
      }

      return index === -1 ? 0 : index;
    },
    maxDayInMonth: function maxDayInMonth(year, month) {
      return new Date(year, month, 0).getDate();
    },
    isDisabledDay: function isDisabledDay(year, month) {
      var day = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var range = this.range;
      return year === range.minYear && month === range.minMonth + 1 ? day < range.minDay : year === range.maxYear && month === range.maxMonth + 1 ? day > range.maxDay || day > this.maxDayInMonth(year, month) : day > this.maxDayInMonth(year, month);
    },
    isDisabledMonth: function isDisabledMonth(year, month) {
      var range = this.range;
      return year === range.minYear ? month < range.minMonth + 1 : year === range.maxYear ? month > range.maxMonth + 1 : false;
    },
    onConfirm: function onConfirm() {
      var year = this.findRule(['yyyy']) ? this.year[this.selectedYear].value : 0;
      var month = this.findRule(['MM']) ? this.month[this.selectedMonth].value : 0;
      var day = this.findRule(['dd']) ? this.day[this.selectedDay].value : 0;
      var hour = this.findRule(['hh']) ? this.hour[this.selectedHour].value : 0;
      var minute = this.findRule(['mm']) ? this.minute[this.selectedMinute].value : 0;
      var second = this.findRule(['ss']) ? this.second[this.selectedSecond].value : 0;
      var value = this.format.replace('yyyy', year).replace('yy', year - 2000 + '').replace('MM', month).replace('dd', day).replace('hh', hour).replace('mm', minute).replace('ss', second);

      if (this.isLongTerm) {
        // 处理长期情况
        this.$emit('confirm', 'indefinitely');
      } else {
        this.$emit('confirm', value);
      }
    }
  },
  watch: {
    startYear: function startYear() {
      this.setStartYear();
    },
    startMonth: function startMonth() {
      this.setStartMonth();
    },
    startDay: function startDay() {
      this.setStartDay();
    },
    startHour: function startHour() {
      this.setStartHour();
    },
    startMinute: function startMinute() {
      this.setStartMinute();
    },
    startSecond: function startSecond() {
      this.setStartSecond();
    }
  }
});

exports.default = index;
